import * as React from 'react';
import { SwipeButton } from './SwipeButton';

export interface SwipeButtonConfig {
    rightButtons: Array<{callback: () => void, classNameActive: string, className: string, stretchOnClick?: boolean}>;
    mainElement: JSX.Element;
    onMainClick?: () => void;
    index: string | number | undefined;
}

export interface SwipeButtonGroupProps {
    buttons: Array<SwipeButtonConfig>;
    buttonHeight: number;
    className?: string;
}

export class SwipeButtonGroup extends React.Component<SwipeButtonGroupProps, {}> {
    protected buttons: Array<SwipeButton> = [];

    public noneOpen = (): boolean => {
        for (const button of this.buttons) {
            if (button != null && button.state != null && button.state.dragMargin !== 0) {
                return false;
            }
        }
        return true;
    };

    public closeGroupMembers = (domNode: HTMLElement | null): void => {
        for (const button of this.buttons) {
            if (button) {
                button.close(domNode);
            }
        }
    };

    public render(): JSX.Element {
        this.buttons = [];
        return (
            <div className={this.props.className ? this.props.className : ''}>
                {this.props.buttons.map((swipeButton, index) => {
                    return (
                        <SwipeButton
                            onClick={swipeButton.onMainClick}
                            height={this.props.buttonHeight}
                            key={swipeButton.index}
                            buttons={swipeButton.rightButtons}
                            noneOpen={this.noneOpen}
                            closeGroupMembers={this.closeGroupMembers}
                            ref={this.addButton}
                        >
                            {swipeButton.mainElement}
                        </SwipeButton>
                    );
                })}
            </div>
        );
    }

    protected addButton = (button: SwipeButton): void => {
        this.buttons.push(button);
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/core-swipe-button/SwipeButtonGroup.tsx